import { Config, HMAC_SHA_256 } from '@nw/shared/config';

export const generateHmacSignature = async (
  key: string,
  msg: string,
  hashingAlgo: string
): Promise<string> => {
  let algo: string | undefined;
  if (hashingAlgo === HMAC_SHA_256) {
    algo = 'SHA-256';
  }

  if (!algo) {
    throw new Error('Unsupported hashing algorithm');
  }

  const enc = new TextEncoder();
  const keyData = enc.encode(key);
  const msgData = enc.encode(msg);

  const cryptoKey = await crypto.subtle.importKey(
    'raw',
    keyData,
    { name: 'HMAC', hash: { name: algo } },
    false,
    ['sign']
  );

  const signature = await crypto.subtle.sign('HMAC', cryptoKey, msgData);

  return Array.from(new Uint8Array(signature))
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('');
};

export const getHmacSha256Signature = (
  msg: string
): Promise<string> | undefined => {
  const secretKey = Config['HMAC_REQUEST_SIGNATURE_SECRET_KEY'];
  if (secretKey) {
    const signature = generateHmacSignature(secretKey, msg, HMAC_SHA_256);
    return signature;
  }
  return undefined;
};
